module.exports = __webpack_public_path__ + "static/media/logo-epa-challenge-10X.6ccd38e7.png";